var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav-tabs"},_vm._l((_vm.menu),function(item,i){return _c('li',{key:i,class:{
      'tab-active': item.name.toUpperCase() === _vm.active.toUpperCase(),
    },on:{"click":function($event){return _vm.setActiveTab(item.name || '')}}},[_c('a',{attrs:{"rel":"nofollow"}},[(item.icon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['far', item.icon],"size":"1x"}}):_vm._e(),_c('span',[_vm._v(_vm._s(item.name || ''))])],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }